var _g, _circle, _path, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "work",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 178.6 189.8",
    style: {
      enableBackground: "new 0 0 178.6 189.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "building",
    className: "opacity-0 animation-movedown"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "fill-green",
    points: "25.4,166.4 25.4,52.8 11.5,52.8 11.5,178.7 169.3,178.7 169.3,166.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.8,
    y: 64.3,
    className: "stroke-white stroke-4",
    width: 158,
    height: 116
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.6,
    y: 116.1,
    className: "stroke-white stroke-4",
    width: 42.3,
    height: 65.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-white stroke-4 fill-green",
    d: "M167.8,50.5H9.8v-7c0-5.5,4.5-10,10-10h138c5.5,0,10,4.5,10,10V50.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "stroke-white stroke-4 fill-dkgreen",
    d: "M9.7,51.5l-5.6,28c-1.5,7.3,2.8,13.4,9.6,13.4s13.2-6.1,14.2-13.4l4-28H9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-white stroke-4 fill-dkgreen",
    d: "M32.3,51.5l-4,28c-1,7.3,3.6,13.4,10.4,13.4s12.8-6.1,13.4-13.4l2.4-28H32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-white stroke-4 fill-dkgreen",
    d: "M55,51.5l-2.4,28C52,86.8,57,92.9,63.7,92.9c6.8,0,12.5-6.1,12.7-13.4l0.8-28H55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-white stroke-4 fill-dkgreen",
    d: "M77.6,51.5l-0.8,28c-0.2,7.3,5.1,13.4,11.9,13.4s12.1-6.1,11.9-13.4l-0.8-28H77.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-white stroke-4 fill-dkgreen",
    d: "M100.2,51.5l0.8,28c0.2,7.3,5.9,13.4,12.7,13.4s11.8-6.1,11.1-13.4l-2.4-28H100.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-white stroke-4 fill-dkgreen",
    d: "M122.9,51.5l2.4,28c0.6,7.3,6.7,13.4,13.4,13.4s11.4-6.1,10.4-13.4l-4-28H122.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-white stroke-4 fill-dkgreen",
    d: "M145.6,51.5l4,28c1,7.3,7.4,13.4,14.2,13.4s11.1-6.1,9.6-13.4l-5.6-28H145.6z"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "sign",
    className: "stroke-white stroke-4 fill-dkgreen animation-movedown opacity-0",
    cx: 89.4,
    cy: 30.6,
    r: 27.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dollar",
    className: "fill-green opacity-0",
    d: "M89.4,39.9c-1.7,0-3.1-1.4-3.1-3.1h-6.1c0,4,2.6,7.4,6.1,8.7v6.7h6.1v-6.7c3.5-1.3,6.1-4.7,6.1-8.7 c0-5.1-4.1-9.2-9.2-9.2c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1c1.7,0,3.1,1.4,3.1,3.1h6.1c0-4-2.6-7.4-6.1-8.7V9.2h-6.1v6.7 c-3.5,1.3-6.1,4.6-6.1,8.7c0,5.1,4.1,9.2,9.2,9.2c1.7,0,3.1,1.4,3.1,3.1S91.1,39.9,89.4,39.9z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "shrub",
    className: "animation-movedown opacity-0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "stroke-white stroke-4 fill-dkgreen",
    d: "M15.3,156.4l3.1,0.1l0.5-2.5c1.1-5.7,6.2-9.9,12-9.9c4.3,0,8.2,2.2,10.4,5.9l1.4,2.4l2.5-1.2 c4.7-2.3,10.1-0.2,12.2,4.3l1.2,2.5l2.6-1c6.4-2.4,12.4,2.4,12.4,8.6c0,5.1-4.1,9.2-9.2,9.2H15.5c-5.1,0-9.2-4.1-9.2-9.2 C6.4,160.6,10.5,156.5,15.3,156.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-white stroke-4 fill-dkgreen",
    d: "M76.1,186.9H2.8v-9.2c0-1.7,1.4-3.1,3.1-3.1h67.2c1.7,0,3.1,1.4,3.1,3.1L76.1,186.9L76.1,186.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "stroke-white stroke-4 fill-dkgreen",
    d: "M172.6,166.3c0,5.1-4.1,9.2-9.2,9.2h-48.9c-5.1,0-9.2-4.1-9.2-9.2c0-6.1,6-11,12.4-8.6l2.6,1l1.2-2.5 c2.1-4.5,7.5-6.6,12.2-4.3l2.5,1.2l1.4-2.4c2.3-3.7,6.1-5.9,10.4-5.9c5.8,0,10.8,4.1,12,9.9l0.5,2.5l2.6-0.1c0.2,0,0.3,0,0.2,0 C168.4,157.1,172.6,161.2,172.6,166.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke-white stroke-4 fill-dkgreen",
    d: "M175.6,187.5h-73.3v-9.2c0-1.7,1.4-3.1,3.1-3.1h67.2c1.7,0,3.1,1.4,3.1,3.1L175.6,187.5L175.6,187.5z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.31e04eca5742e56addc95851c72aee9a.svg";
export { ForwardRef as ReactComponent };